import './_article-image.scss';

export default () => {};
